import React, { useCallback } from 'react';
import { Message } from '@naf/input';
import { UseFormReturn } from 'react-hook-form';
import { useEmailValidation } from '@shared/hooks/useEmailValidation';
import { getSuggestedEmail, ERROR_MESSAGE_INVALID_EMAIL } from '@shared/components/EmailFieldContent';
import { EmailSuggestion } from '@shared/components/EmailFieldContent/EmailSuggestion';
import S from './Form/Styles';

interface EmailProps {
  disabled?: boolean;
  onChange: (item: any) => void;
  error?: boolean;
  name: string;
  watch?: UseFormReturn['watch'];
  value: string;
  width?: 'Wide' | 'Small';
  id?: string;
  setWidth?: boolean;
}

export const Email = ({ disabled, onChange, error = false, name, watch, value, width, id, setWidth }: EmailProps) => {
  const emailValue = (watch && watch(name)) || undefined;

  const { isValid, suggestedHostName, isLoading } = useEmailValidation(emailValue || '', !disabled && !!emailValue);

  const suggestedEmail = getSuggestedEmail(emailValue || '', suggestedHostName);

  const showValidationError = isValid === false && !isLoading;
  const hasError = error || showValidationError;

  const handleSuggestionClick = useCallback(() => {
    if (suggestedEmail) {
      onChange(suggestedEmail);
    }
  }, [suggestedEmail, onChange]);

  return (
    <>
      <S.StyledInput
        id={id}
        name={name}
        type="text"
        disabled={disabled}
        error={hasError}
        value={value}
        onChange={onChange}
        width={width}
        autoComplete="email"
        setWidth={setWidth}
      />
      {showValidationError && <Message error>{ERROR_MESSAGE_INVALID_EMAIL}</Message>}
      {!!suggestedEmail && (
        <EmailSuggestion suggestedEmail={suggestedEmail} onSuggestionClick={handleSuggestionClick} />
      )}
    </>
  );
};
